import { defineComponent as c, useSlots as u, computed as f, openBlock as d, createElementBlock as m, normalizeClass as p, unref as a, renderSlot as v } from "vue";
import { useNamespace as _ } from "./index559.js";
var N = /* @__PURE__ */ c({
  name: "ElContainer",
  __name: "container",
  props: {
    direction: { type: String, required: !1 }
  },
  setup(l) {
    const t = l, e = u(), r = _("container"), i = f(() => t.direction === "vertical" ? !0 : t.direction === "horizontal" ? !1 : e && e.default ? e.default().some((o) => {
      const s = o.type.name;
      return s === "ElHeader" || s === "ElFooter";
    }) : !1);
    return (n, o) => (d(), m(
      "section",
      {
        class: p([a(r).b(), a(r).is("vertical", i.value)])
      },
      [
        v(n.$slots, "default")
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  N as default
};
